module.exports = __webpack_public_path__ + "img/건강한 고령자(AIP).baa4d298.png";